import React, { useState } from 'react';

const faqDatabase = [
  {
    category: "Procurement & B2B Orders",
    items: [
      { q: "What is your Minimum Order Quantity (MOQ) for commercial scopes?", a: "Our baseline MOQ varies depending on the raw material tier. Generally, standard cast alloy and brass curations carry a friendly minimum of 10 units, while customized architectural installations tailored to high-end hospitality scopes can be commissioned starting from a single unit layout assignment." },
      { q: "Do you supply physical product blueprint samples before mass production?", a: "Yes. Once an official project brief or letter of intent is verified by our procurement desk, our engineering team can arrange a physical prototype configuration or a certified material sample board swatch for studio evaluation." }
    ]
  },
  {
    category: "Bespoke Customization & Casting",
    items: [
      { q: "Can we request alterations to physical sizing metrics and raw alloy polishes?", a: "Bespoke engineering is our specialty. You can adjust spatial dimensions, request specific hand-blown glass textures, or apply specialized surface patinas (such as oil-rubbed bronze, antiqued brass, or custom stone turning) via our Custom Studio desk." },
      { q: "Are your lighting fixtures compatible with commercial dimming engines?", a: "Perfectly. All luxury blueprints are structurally configured to integrate seamlessly with standard architectural dimming loops, including Triac, 0-10V, and DALI digital control automation matrix infrastructures." }
    ]
  },
  {
    category: "Logistics & Project Staging",
    items: [
      { q: "What are your standard manufacturing lead times for boutique hotels?", a: "Standard pipeline collections dispatch within 14 to 21 business days. Grand-scale contract custom design orders requiring specialized sand-casting molds or artisan glass blowing typically cycle through a 4 to 6 week staging matrix prior to secure container dispatch." },
      { q: "Do you ship internationally for global hospitality chains?", a: "Yes. We coordinate reliable global logistics with secure crates and high-density foam framing to serve corporate chains, boutique stays, and trade distributors across over 50 countries safely." }
    ]
  }
];

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  let globalCounter = 0;

  return (
    <div className="legal-universe-wrapper white-gallery-canvas">
      <section className="legal-hero-banner text-center">
        <div className="container dynamic-fade-rise">
          <span className="legal-eyebrow">📋 CUSTOMER DESK RESOURCES</span>
          <h1>Frequently Asked Questions<br /><span className="dark-gold-txt">B2B Procurement Support Matrix</span></h1>
          <div className="legal-title-line"></div>
          <p>Find technical clarifications regarding manufacturing cycles, project custom capabilities, scalable supply models, and worldwide shipping frameworks.</p>
        </div>
      </section>

      <section className="container architectural-narrow-column">
        {faqDatabase.map((sec, secIdx) => (
          <div key={secIdx} className="faq-category-block">
            <h2 className="faq-category-title">{sec.category}</h2>
            <div className="faq-accordion-group">
              {sec.items.map((item, itemIdx) => {
                const currentIndex = globalCounter++;
                const isOpen = activeIndex === currentIndex;
                return (
                  <div key={itemIdx} className={`faq-accordion-item ${isOpen ? 'active-pane' : ''}`}>
                    <button className="faq-trigger-btn" onClick={() => toggleAccordion(currentIndex)}>
                      <span>{item.q}</span>
                      <span className="accordion-icon-marker">{isOpen ? '−' : '+'}</span>
                    </button>
                    <div className="faq-content-slider" style={{ maxHeight: isOpen ? '250px' : '0px' }}>
                      <p className="faq-answer-txt">{item.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}